import React from 'react';

import { xcss, Box } from '@atlaskit/primitives';

import { ReactionContainerType, ReactionLocation } from '@confluence/reactions';
import { LIVE_PAGE_SUBTYPE } from '@confluence/live-pages-utils';
import { fg } from '@confluence/feature-gating';

import { ReactionsLoader } from '@confluence/reactions/entry-points/ReactionsLoader';

export type LivePagesByLineReactionsProps = {
	contentId: string;
	spaceId: string;
	isDisabled?: boolean;
	isContentCreationPanelOpen: boolean;
	isSubtle?: boolean;
};

const templateSidebarWidth = 320;

const floatingContainerStyles = xcss({
	display: 'flex',
	position: 'fixed',
	justifyContent: 'right',
	bottom: 'space.300',
	right: 'space.100',
	zIndex: 'layer',
	transition: 'left 600ms',
});

const subtleReactionsFloatingContainerStyles = xcss({
	display: 'flex',
	justifyContent: 'left',
	zIndex: 'layer',
	transition: 'left 600ms',
	marginBottom: 'space.025',
});

const containerStylesWhenPanelOpen = xcss({
	paddingRight: 'space.100',
	right: `${templateSidebarWidth}px`,
	transition: 'right 600ms',
});

export const LivePagesByLineReactions = ({
	contentId,
	spaceId,
	isDisabled = false,
	isContentCreationPanelOpen,
	isSubtle,
}: LivePagesByLineReactionsProps) => (
	<Box
		xcss={[
			isSubtle ? subtleReactionsFloatingContainerStyles : floatingContainerStyles,
			isContentCreationPanelOpen && containerStylesWhenPanelOpen,
		]}
		testId="live-pages-reactions"
	>
		<ReactionsLoader
			contentId={contentId}
			location={ReactionLocation.PAGE}
			containerId={spaceId}
			containerType={ReactionContainerType.PAGE}
			contentSubType={LIVE_PAGE_SUBTYPE}
			summaryViewEnabled
			hideNoReactionsText
			readOnly={isDisabled}
			isSubtle={isSubtle}
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			hidePlaceholder={Boolean(process.env.REACT_SSR || window.__SSR_RENDERED__)}
			isViewOnly={fg('confluence_new_reactions_entry_point_changes')}
		/>
	</Box>
);
